import { css } from '@/styled-system/css';

export const otherStatesSection = css({
  marginTop: '6x',
  paddingTop: '4x',
  borderTopWidth: '1px',
  borderTopStyle: 'solid',
  borderTopColor: 'hpxGrey400',
});

export const otherStatesHeading = css({
  color: 'hpxBlue600',
  marginBottom: '2x',
});

export const otherStatesList = css({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  rowGap: '1x',
  columnGap: '2x',
  listStyle: 'none',
  margin: 0,
  padding: 0,
  sm: {
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  },
  md: {
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
  },
  lg: {
    gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
  },
  xl: {
    gridTemplateColumns: 'repeat(6, minmax(0, 1fr))',
  },
});

export const otherStatesItem = css({
  fontSize: 'md',
});
